export const FORM_VALIDATION_DEBOUNCE = 1000;
